export const translationStrings = [
  'common.buttons.edit',
  'common.buttons.save',
  'common.buttons.cancel',
  'common.buttons.back',
  'common.prompt.unsaved.cancel',
  'common.prompt.unsaved.leave',
  'common.prompt.unsaved.title',
] as const;
